module.exports = __webpack_public_path__ + "static/media/hack1.2fc2f936.jpg";